import classnames from "classnames"

// Components
import { Input } from "@mobi/ds"
import IAEmail from "./types"
import If from "@mobi/components/If"

// Hooks
import useEmail from "./hooks"

// Styles
import "./Email.scss"

const Email = (props: IAEmail) => {
  const {
    customMessages,
    error = {
      type: "",
    },
    errorMessage,
    field,
    fieldId,
    hasErrorMessage,
    isEmptyList,
    isInvalid,
    options = [],
    required,
    onBlur,
    onCustomChange,
    onFocus,
    onKeyDown,
    onSelectItem,
  } = useEmail(props)

  const {
    name,
    label = "email",
    disabled,
    type = "email",
    allowSuggestions = true,
  } = props

  const inputProps = {
    ...props,
    disabled,
    errorMessage: customMessages[error?.type] || errorMessage,
    id: fieldId || name,
    isValid: !isInvalid,
    label,
    name,
    required,
    spellCheck: "false",
    type,
    value: field.value,
    onBlur,
    onChange: onCustomChange,
    onFocus,
    autoComplete: "off",
    "aria-invalid": hasErrorMessage || "false",
    ...(hasErrorMessage && { "aria-describedby": `error-${name}` }),
    "aria-required": required,
    control: props.control,
  }

  const comboBoxProperties = {
    onKeyDown,
    role: "combobox",
    tabIndex: "0",
    "aria-autocomplete": "list",
    "aria-owns": `option-list-${fieldId}`,
    ...(options.length > 0 && {
      "aria-activedescendant": `option-${fieldId}_0`,
    }),
    "aria-expanded": !!(options && options.length > 0),
  }

  return (
    <div
      className={classnames("ds-email", {
        "ds-email--invalid": isInvalid,
        "ds-email--disabled": disabled,
      })}
    >
      <div className="ds-email__field">
        <Input.Default
          {...inputProps}
          {...(allowSuggestions ? comboBoxProperties : {})}
        />
      </div>

      <If
        condition={allowSuggestions}
        renderIf={
          <div
            id={`option-list-${fieldId}`}
            className={classnames("ds-email__option-list", {
              "ds-email__option-list--hidden": isEmptyList,
            })}
          >
            <If
              condition={options && options.length}
              renderIf={
                <ul
                  id={`results-${fieldId}`}
                  className="ds-email__result-list"
                  role="listbox"
                  tabIndex={0}
                  onKeyDown={onKeyDown}
                >
                  {options.map((option, index) => (
                    <li
                      id={`option-${fieldId}_${index}`}
                      className="ds-email__item"
                      onClick={() => { 
                        onSelectItem(option)
                        document.querySelector("#ds-field-email").focus()
                      }}
                      key={index}
                      role="option"
                      aria-selected="false"
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              }
            />
          </div>
        }
      />

      <If
        condition={allowSuggestions}
        renderIf={
          <div className="ds-email__feedback-msg" role="status">
            <If
              condition={options && options.length}
              renderIf={`${
                options ? options.length : ""
              } sugestões encontradas, use as teclas para cima e para baixo para navegar`}
            />
          </div>
        }
      />
    </div>
  )
}

export default Email
